import apiClient from './apiClient'


const getWorklogReport = (tenant, year, month) => {
  return apiClient.get(`/${tenant}/WorklogReport/${year}/${month}`)
}

const acceptWorklogReport = (tenant, contactId, year, month) => {
  return apiClient.put(`/${tenant}/WorklogReport/${contactId}/${year}/${month}/accept`)
}

const unacceptWorklogReport = (tenant, contactId, year, month, worklogReport) => {
  return apiClient.put(`/${tenant}/WorklogReport/${contactId}/${year}/${month}/unaccept`)
}


export default {
  getWorklogReport,
  acceptWorklogReport,
  unacceptWorklogReport
}
